exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nsvg[data-v-7a937076] {\n  margin-left: 4px;\n}\n.fa-pause[data-v-7a937076] {\n  color: #ffd181 !important;\n  font-size: 1.2rem;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n", ""]);

// exports
